import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import * as catConsts from "./constants";

export const state = {
  transaction: null,
  transactions: [],
  isLoadingList: true,
  transactionAssociatedList: [],
  pagination: {
    count: 10,
    total: 0
  }
};

export const getters = {
  [catConsts.GETTERS_TRANSACTION_LIST]: state => {
    return state.transactions;
  },
  [catConsts.GETTERS_TRANSACTION_ASSOCIATED_LIST]: state => {
    return state.transactionAssociatedList;
  },
  [catConsts.GETTERS_TRANSACTION_ASSOCIATED_PAGINATION]: state => {
    return state.pagination;
  },
  [catConsts.GETTERS_TRANSACTION_LIST_LOADING]: state => {
    return state.isLoadingList;
  },
  [catConsts.GETTERS_TRANSACTION_DETAIL]: state => state.transaction
};

export const actions = {
  [catConsts.ACTION_GET_TRANSACTION_LIST]: ({ commit }, options) => {
    if (!options.keepData) {
      commit(catConsts.MUTATION_GET_TRANSACTION_LIST, []);
    }
    commit(catConsts.MUTATION_SET_TRANSACTION_LIST_LOADING, true);
    makeCall(
      getEndPoints().transactions.getList,
      buildOptions("GET", options),
      commit
    )
      .then(response => {
        if (response.data) {
          commit(catConsts.MUTATION_GET_TRANSACTION_LIST, response);
        }
      })
      .finally(() =>
        commit(catConsts.MUTATION_SET_TRANSACTION_LIST_LOADING, false)
      );
  },
  [catConsts.ACTION_GET_TRANSACTION_ASSOCIATED_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().transactions.getAssociatedList.replace(
        ":filesource_id",
        options.id
      ),
      buildOptions("POST", options.data),
      commit
    ).then(response => {
      if (response.data) {
        commit(catConsts.MUTATION_GET_TRANSACTION_ASSOCIATED_LIST, response);
      }
    });
  },
  [catConsts.ACTION_GET_TRANSACTION_DETAIL]: ({ commit }, options) => {
    makeCall(
      getEndPoints().transactions.getDetail.replace(':transaction_id', options.id),
      buildOptions("GET", options),
      commit
    )
      .then(response => {
        if (response.data) {
          commit(catConsts.MUTATION_GET_TRANSACTION_DETAIL, response.data);
          if (options.callback) {
            options.callback(response.data);
          }
        }
      });
  },
};

export const mutations = {
  [catConsts.MUTATION_GET_TRANSACTION_LIST]: (state, transactions) => {
    state.transactions = transactions;
  },
  [catConsts.MUTATION_GET_TRANSACTION_ASSOCIATED_LIST]: (
    state,
    transactionAssociatedList
  ) => {
    state.transactionAssociatedList = transactionAssociatedList;
  },
  [catConsts.MUTATION_SET_TRANSACTION_LIST_LOADING]: (state, isLoading) => {
    state.isLoadingList = isLoading;
  },
  [catConsts.MUTATION_GET_TRANSACTION_DETAIL]: (state, transaction) => state.transaction = transaction
};

export default {
  actions,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/transactions/index.js